module.exports = __webpack_public_path__ + "img/icon-long-arrow.694b5d38.svg";